module.exports = __webpack_public_path__ + "static/lockup-10090bcfd318cba705fe1d9699b6ae9a.svg";